import { Dispatch } from "redux";
import { ApiService } from "../../../../services/apiService";
import { routes } from "../../../../services/paths";
import { handleRequestErrors } from "../../../../shared/utils";
import { appConstants } from "../../../action-constants/inapp.constants";
import {
  CreateAttributeTemplatePayload,
  GetAttributeTemplatesResponse,
  AttributeTemplateItem,
  AttributeTemplateDeleteResponse,
  UpdateAttributeTemplatePayload,
} from "../../../../types/app/attributeTemplateTypes";

export const GetAttributeTemplates = (actionPayload: string | "CLEAR") => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.ATTRIBUTE_TEMPLATES}?${actionPayload}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATES_PENDING, params };
  }
  function success(response: GetAttributeTemplatesResponse) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATES_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATES_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATES_RESET, clear_data: "" };
  }
};

export const GetAttributeTemplate = (
  actionPayload: string | "CLEAR",
  id?: string,
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.ATTRIBUTE_TEMPLATES}/${id}`,
        http_method: "GET",
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATE_PENDING, params };
  }
  function success(response: AttributeTemplateItem) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_ATTRIBUTE_TEMPLATE_RESET };
  }
};

export const CreateAttributeTemplate = (
  actionPayload: CreateAttributeTemplatePayload | "CLEAR",
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: routes.ATTRIBUTE_TEMPLATES,
        http_method: "POST",
        data: actionPayload,
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.CREATE_ATTRIBUTE_TEMPLATE_PENDING, params };
  }
  function success(response: AttributeTemplateItem) {
    return { type: appConstants.CREATE_ATTRIBUTE_TEMPLATE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.CREATE_ATTRIBUTE_TEMPLATE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.CREATE_ATTRIBUTE_TEMPLATE_RESET };
  }
};

export const UpdateAttributeTemplate = (
  actionPayload: UpdateAttributeTemplatePayload | "CLEAR",
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.ATTRIBUTE_TEMPLATES}/${actionPayload.id}`,
        http_method: "PUT",
        data: actionPayload,
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.UPDATE_ATTRIBUTE_TEMPLATE_PENDING, params };
  }
  function success(response: AttributeTemplateItem) {
    return { type: appConstants.UPDATE_ATTRIBUTE_TEMPLATE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.UPDATE_ATTRIBUTE_TEMPLATE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.UPDATE_ATTRIBUTE_TEMPLATE_RESET };
  }
};

export const DeleteAttributeTemplate = (
  actionPayload: string | "CLEAR",
  id: string,
  forceDelete = false,
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      const apiConsume = ApiService.request({
        url: `${routes.ATTRIBUTE_TEMPLATES}/${id}?forceDelete=${forceDelete}`,
        http_method: "DELETE",
      });

      dispatch(request(apiConsume));

      return apiConsume
        .then((response: any) => dispatch(success(response.data)))
        .catch((error: any) => dispatch(failure(handleRequestErrors(error))));
    };
  }

  return (dispatch: Dispatch) => dispatch(clear());

  function request(params: any) {
    return { type: appConstants.DELETE_ATTRIBUTE_TEMPLATE_PENDING, params };
  }
  function success(response: AttributeTemplateDeleteResponse) {
    return { type: appConstants.DELETE_ATTRIBUTE_TEMPLATE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DELETE_ATTRIBUTE_TEMPLATE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DELETE_ATTRIBUTE_TEMPLATE_RESET };
  }
};
